module.exports = __webpack_public_path__ + "static/media/meteor.d3cc9ba7.png";